<template>
  <div>
    <v-container>
        <zera-admin-dashboard v-if="Admin"/>
        <zera-staff-dashboard v-else/>
    </v-container>
   </div>
 </template>
 <script>

 import {
   mapMutations
 } from 'vuex'
   export default {
     data: () => ({
    
     }),
     beforeCreate: function () {
       if (!this.$session.exists()) {
         this.$router.push('/')
       } 
     },
     created() {
      this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
        this.setLoggedIn(true) 
      this.VALIDATEPAGEACCESS()

     },
     computed:{
      Admin(){
        if(this.$session.get('role') == 'Administrator') {
          return true
        } return false
      },
     },
     methods: {
       ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
    
     },
   }
 </script>